import { createBrowserClient } from '@supabase/ssr';

const supabaseUrl = typeof process.env.NEXT_PUBLIC_SUPABASE_URL === 'string' ? process.env.NEXT_PUBLIC_SUPABASE_URL : '';
const supabaseAnonKey = typeof process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY === 'string' ? process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY : '';

export function createClient() {
  return createBrowserClient(supabaseUrl, supabaseAnonKey);
}

// Create a singleton instance for use throughout the app
export const supabase = createBrowserClient(supabaseUrl, supabaseAnonKey);